// This file configures browser-side instrumentation (logtape + OTel logs/traces).
// The added config here will be used whenever a user loads a page in their browser.

import { instrumentClient } from './instrumentation/client'

instrumentClient()
